module.exports = __webpack_public_path__ + "static/media/new-york-logo.54135742.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/new-york-logo.svg
// module id = 21
// module chunks = 0